'use es6';

import PropTypes from 'prop-types';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import ExchangeUrlErrorMessage from './ExchangeUrlErrorMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import text from 'I18n/utils/unescapedText';
import { jsx as _jsx } from "react/jsx-runtime";
const LANG_ROUTE = 'InboxConnectUtils.genericInboxForm';

/**
 * Advanced Exchange options to explicitly declare username, domain, and Exchange EWS Url.
 * @internal
 */
const ExchangeServerSettings = ({
  isRequired,
  // should be true if autodiscovery failed
  validationMessages,
  value,
  disabled,
  handleFieldChange
}) => {
  const {
    exchangeUrl
  } = value;
  const exchangeUrlErrorMessage = ExchangeUrlErrorMessage({
    validationMessages,
    exchangeUrl,
    onSuggestionClick: suggestedUrl => handleFieldChange(SyntheticEvent(suggestedUrl), 'exchangeUrl')
  });
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "InboxConnectUtils.genericInboxForm.exchange.urlLabel"
    }),
    required: isRequired,
    error: Boolean(exchangeUrlErrorMessage),
    help: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "InboxConnectUtils.genericInboxForm.exchange.supportedProducts"
    }),
    validationMessage: exchangeUrlErrorMessage,
    children: /*#__PURE__*/_jsx(TextInput, {
      value: exchangeUrl,
      name: "exchangeUrl",
      disabled: disabled,
      placeholder: text(`${LANG_ROUTE}.exchange.urlPlaceholder`),
      defaultValue: value.customUsername,
      onChange: evt => handleFieldChange(evt, 'exchangeUrl')
    })
  });
};
ExchangeServerSettings.propTypes = {
  isRequired: PropTypes.bool.isRequired,
  validationMessages: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired,
  disabled: PropTypes.bool.isRequired,
  handleFieldChange: PropTypes.func.isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
ExchangeServerSettings.defaultProps = {
  isRequired: false
};
export default ExchangeServerSettings;